import React, { useState } from "react";
import "./CardSpotlight.css";

const CardSpotlight = ({ children, className = "", radius = 220, color = "rgba(0, 200, 255, 0.25)", ...rest }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [opacity, setOpacity] = useState(0);

    const handleMouseMove = (event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setPosition({ x: event.clientX - rect.left, y: event.clientY - rect.top });
    };

    return (
        <div
            className={`card-spotlight ${className}`}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => setOpacity(1)}
            onMouseLeave={() => setOpacity(0)}
            {...rest}
        >
            <div
                className="card-spotlight-glow"
                style={{
                    opacity,
                    background: `radial-gradient(${radius}px circle at ${position.x}px ${position.y}px, ${color}, transparent 80%)`,
                }}
            />
            <div className="card-spotlight-content">{children}</div>
        </div>
    );
};

export default CardSpotlight;
